<template>
  <div>
    <label v-if="showLangFilter"><small><strong>{{ trans('language') }}</strong></small></label>
    <b-form v-if="showLangFilter" inline>
      <b-form-radio
        v-model="lang_filter"
        value="no"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('no') }}</b-form-radio>
      <b-form-radio
        v-model="lang_filter"
        value="en"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('english') }}</b-form-radio>
      <b-form-radio
        v-model="lang_filter"
        value="fr"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('french') }}</b-form-radio>
    </b-form>

    <label :class="showLangFilter ? 'mt-3' : ''"><small><strong>{{ trans('age') }}</strong></small></label>
    <b-form inline>
      <b-form-radio
        v-model="age_filter"
        value="no"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2"
      >{{ trans('no') }}</b-form-radio>
      <b-form-radio
        v-model="age_filter"
        value="children"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('children') }}</b-form-radio>
      <b-form-radio
        v-model="age_filter"
        value="adults"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('adults') }}</b-form-radio>
      <b-form-radio
        v-model="age_filter"
        value="range"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('range') }}</b-form-radio>
    </b-form>
    <b-form inline v-show="age_filter=='range'">
      <label class="mr-2 w-20">Min</label>
      <b-form-input
        size="sm"
        class="mr-2 narrow"
        type="number"
        v-model="age_min"
        min="0"
        v-on:input="onChange"
        :disabled="!canFilter"
      />
      <label class="mr-2">Max</label>
      <b-form-input
        size="sm"
        class="narrow"
        type="number"
        v-model="age_max"
        min="0"
        v-on:input="onChange"
        :disabled="!canFilter"
      />
    </b-form>

    <label class="mt-3"><small><strong>{{ trans('birthday') }}</strong></small></label>
    <b-form inline>
      <b-form-radio
        v-model="birthday_filter"
        value="no"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('no') }}</b-form-radio>
      <b-form-radio
        v-model="birthday_filter"
        value="month"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('month') }}</b-form-radio>
      <b-form-select
        size="sm"
        v-show="birthday_filter=='month'"
        v-model="birthday_month"
        v-on:change="onChange"
        :disabled="!canFilter"
        :options="months"
      />
    </b-form>

    <label class="mt-3"><small><strong>{{ trans('gender') }}</strong></small></label>
    <b-form inline>
      <b-form-radio
        v-model="gender_filter"
        value="no"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('no') }}</b-form-radio>
      <b-form-radio
        v-model="gender_filter"
        value="male"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('male') }}</b-form-radio>
      <b-form-radio
        v-model="gender_filter"
        value="female"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('female') }}</b-form-radio>
      <b-form-radio
        v-model="gender_filter"
        value="not_specified"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('not_specified') }}</b-form-radio>
    </b-form>

    <label v-if="!hideRecipientFilter" class="mt-3"><small><strong>{{ trans('recipient') }}</strong></small></label>
    <b-form v-if="!hideRecipientFilter" inline>
      <b-form-radio
        v-model="recipient_filter"
        value="account_owner"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans('account_owner') }}</b-form-radio>
      <b-form-radio
        v-model="recipient_filter"
        value="participant"
        v-on:input="onChange"
        :disabled="!canFilter"
        class="mr-2">{{ trans(['amilia_import_program', 'class_participants'].indexOf(this.type) >= 0 ? 'participant' : 'member') }}</b-form-radio>
    </b-form>
  </div>
</template>

<script>
  export default {
    props: {
      canFilter: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'amilia_import_program', // or amilia_import_membership, or class_participants
      },
      hideRecipientFilter: {
        type: Boolean,
        default: false,
      },
      showLangFilter: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default() {
          return {
            age_filter: 'no',
            age_min: 0,
            age_max: 99,
            birthday_filter: 'no',
            birthday_month: moment().startOf('month').format('YYYY-MM-DD'),
            gender_filter: 'no',
            recipient_filter: 'account_owner', // or participant, both_guardians
            lang_filter: 'no',
          }
        },
      },
    },
    data() {
      return {
        trans: trans,
        months: (() => {
          let months = []
          for (var i = 0; i < 12; i++) {
            let d = moment().startOf('month').add(i, 'months')
            months.push({
              value: d.format('YYYY-MM-DD'),
              text: d.format('MMMM'),
            })
          }
          return months
        })(),
        // Filters
        age_filter: this.value.age_filter,
        age_min: this.value.age_min,
        age_max: this.value.age_max,
        birthday_filter: this.value.birthday_filter,
        birthday_month: this.value.birthday_month,
        gender_filter: this.value.gender_filter,
        recipient_filter: this.value.recipient_filter,
        lang_filter: this.value.lang_filter
      }
    },
    watch: {
      value() {
        this.age_filter = this.value.age_filter
        this.age_min = this.value.age_min
        this.age_max = this.value.age_max
        this.birthday_filter = this.value.birthday_filter
        this.birthday_month = this.value.birthday_month
        this.gender_filter = this.value.gender_filter
        this.recipient_filter = this.value.recipient_filter
        this.lang_filter = this.value.lang_filter
      }
    },
    methods: {
      onChange() {
        this.$emit('input', {
          age_filter: this.age_filter,
          age_min: parseInt(this.age_min, 10),
          age_max: parseInt(this.age_max, 10),
          birthday_filter: this.birthday_filter,
          birthday_month: this.birthday_month,
          gender_filter: this.gender_filter,
          recipient_filter: !this.hideRecipientFilter ? this.recipient_filter : undefined,
          lang_filter: this.showLangFilter ? this.lang_filter : undefined,
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (this.recipient_filter == 'guardians') {
          this.recipient_filter = 'account_owner'
          this.onChange()
        }
      })
    },
  }
</script>